export enum BudgetAuthErrorCode {
  UNAUTHORIZED = "unauthorized",
}

export enum BudgetAuthErrorMessage {
  UNAUTHORIZED = "Os dígitos informados não conferem com o CPF do paciente deste orçamento",
}
